import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { DateInputInput } from '../../internal/components/DateInputInput';
import { useDateLimitValue } from '../../internal/hooks';
export var DateInputMobile = /*#__PURE__*/React.forwardRef(function DateInputMobile(props, ref) {
  var min = useDateLimitValue(props.min);
  var max = useDateLimitValue(props.max);
  return /*#__PURE__*/React.createElement(DateInputInput, _extends({}, props, {
    ref: ref,
    min: min,
    max: max
  }));
});